import { Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ControlsOf } from '../../../shared/forms/forms-common';
import { IRegisterCommand } from '../../../shared/model/fss.api';
import { FieldComponent } from '../../../shared/ui/field/field';
import { FormControlPipe } from '../../../shared/pipes/form-control.pipe';
import { TextInput } from '../../../shared/ui/text-input/text-input';
import { Building05 } from '../../../shared/icons/building-05/building-05';
import { Hash02 } from '../../../shared/icons/hash-02/hash-02';
import { HomeLine } from '../../../shared/icons/home-line/home-line';
import { MarkerPin01 } from '../../../shared/icons/marker-pin-01/marker-pin-01';
import { Map01 } from '../../../shared/icons/map-01/map-01';
import { User01 } from '../../../shared/icons/user-01/user-01';
import { Phone } from '../../../shared/icons/phone/phone';
import { Arrow } from '../../../shared/icons/arrow/arrow';
import { ButtonComponent, ButtonSeverity, ButtonSize } from '../../../shared/ui/button/button';

@Component({
  standalone: true,
  selector: 'app-register-step-2',
  imports: [
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    FloatLabelModule,
    IconFieldModule,
    InputIconModule,
    FieldComponent,
    FormControlPipe,
    TextInput,
    Building05,
    Hash02,
    HomeLine,
    MarkerPin01,
    Map01,
    User01,
    Phone,
    Arrow,
    ButtonComponent,
  ],
  templateUrl: './register-step-2.html',
  styleUrl: './register-step-2.scss',
})
export class RegisterStep2 {
  form = input.required<FormGroup<ControlsOf<IRegisterCommand>>>();
  isLegalEntity = input.required<boolean>();
  isValid = input.required<boolean>();

  next = output<void>();
  back = output<void>();
  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;
}
